module.exports = __webpack_public_path__ + "static/media/undo.bb1e95df.png";